module.exports = __webpack_public_path__ + "img/close.5b5ae71b.svg";